document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] .search-input input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });

  const checkoutBtn = document.querySelector('.cart-order__recap .button.button--xl[name="checkout"]');
  if (!checkoutBtn) return;

  // first disable
  checkoutBtn.style.pointerEvents = "none";
  checkoutBtn.style.opacity = "0.5";
  checkoutBtn.style.cursor = "not-allowed";

  // after 5s enable
  setTimeout(() => {
    checkoutBtn.style.pointerEvents = "auto";
    checkoutBtn.style.opacity = "1";
    checkoutBtn.style.cursor = ""; 
    console.log("Cart drawer enabled");
  }, 2000);
});
